import { render, staticRenderFns } from "./image_diff_overlay.vue?vue&type=template&id=1676a796"
import script from "./image_diff_overlay.vue?vue&type=script&lang=js"
export * from "./image_diff_overlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports